import { render, staticRenderFns } from "./SelectDossier.vue?vue&type=template&id=197c11bc"
import script from "./SelectDossier.vue?vue&type=script&lang=ts"
export * from "./SelectDossier.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports